<template>
  <span>{{value_}}</span>
</template>

<script>
export default {
  name: 'ThrottleRender',
  props: {
    getValue: {
      type: Function,
      required: true,
    },
    duration: {
      type: Number,
      default: 100,
    },
  },
  data() {
    return {
      value_: this.getValue(),
      interval: setInterval(() => this.value_ = this.getValue(), this.duration),
    }
  },
  destroyed() {
    clearInterval(this.interval)
  },
}
</script>
